import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationChoiceTile } from "web_myplann/Inspiration/Components/InspirationChoiceTile";
import { INSPIRATION_SCENARIO_LABELS } from "web_myplann/Inspiration/constants";
import type { InspirationScenarioKey } from "web_myplann/Inspiration/Types/InspirationTypes";
import { formatPercent } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	scenarioKey: InspirationScenarioKey;
	rate: number;
	value: string;
	note?: string;
	recommendedLabel?: string;
	selected: boolean;
	onClick: () => void;
};

export const InspirationScenarioCard: FC<Props> = ({
	scenarioKey,
	rate,
	value,
	note,
	recommendedLabel,
	selected,
	onClick,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<InspirationChoiceTile selected={selected} onClick={onClick}>
			<Typography
				variant="button"
				mb={theme.spacingTokens.xs}
				color={selected ? theme.palette.blue.main : theme.palette.grey[500]}
				textTransform="uppercase"
				textAlign="center"
			>
				{t(INSPIRATION_SCENARIO_LABELS[scenarioKey])}
			</Typography>
			<Typography variant="hint" color={theme.palette.grey[500]} tabular>
				{`${formatPercent(rate * 100, 0)} ${t(Resources.Inspiration.perYear)}`}
			</Typography>
			<Typography
				variant="subtitle3"
				color={selected ? theme.palette.blue.main : theme.palette.grey[900]}
				tabular
				mt={theme.spacingTokens.xsm}
			>
				{value}
			</Typography>
			{note && (
				<Typography
					variant="hint"
					color={theme.palette.grey[500]}
					tabular
					mt={theme.spacingTokens.xxs}
				>
					{note}
				</Typography>
			)}
			{recommendedLabel && (
				<Typography
					variant="hint"
					color={theme.palette.green.main}
					mt={theme.spacingTokens.xxs}
				>
					{recommendedLabel}
				</Typography>
			)}
		</InspirationChoiceTile>
	);
};
